let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kiA0q")).then(() => parcelRequire('exMWS'));